export const API_URL = String(import.meta.env.VITE_API_URL || '')
/** Google OAuth 2.0 Web client ID (Google Cloud Console); enables Sign in with Google when set. */
export const GOOGLE_CLIENT_ID = String(import.meta.env.VITE_GOOGLE_CLIENT_ID || '')
export const DELIVERY_API = String(import.meta.env.VITE_DELIVERY_API_URL || '')